import { makeStyles } from '@material-ui/core/styles';

const useAttachmentPreviewStyles = makeStyles({
  root: {
    width: 100,
    height: 100,
    borderRadius: 8,
    background: '#F5F5F5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    position: 'relative',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
    '&:hover': {
      opacity: 0.35,
    },
    '&:hover $eyeOverlay': {
      opacity: 1,
      pointerEvents: 'auto',
    },
  },
  eyeOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 0.2s',
    background: 'rgba(0,0,0,0.45)',
    pointerEvents: 'none',
    borderRadius: 8,
  },
});

export default useAttachmentPreviewStyles;
